<div *ngIf="ssData" [@fadeIn]="true" [ngClass]="ccss.getClass('ss_promo')">
  <div
    class="base-promotional-shopper"
    ngClass.lt-md="mobile"
    ngClass.gt-sm="desktop"
    data-cy="promotional-smartshopper.base"
  >
    <platform-page-container
      [fullscreen]="breakpoints.isMobile"
      [contentSpacing]="false"
    >
      <div fxLayout="column" fxLayoutAlign="space-evenly center">
        <h2 class="head" data-cy="promotional-smartshopper.header">
          {{ 'promotional_ss_head' | translate }}
        </h2>
        <div class="divider"></div>
        <p class="subhead" data-cy="promotional-smartshopper.subHeader">
          {{
            'promotional_ss_subhead'
              | translate: { value: ('smartshopper_pat_phone' | translate) }
          }}
        </p>

        <div
          class="ss-info-container"
          fxLayout.gt-sm="row"
          fxLayout.lt-md="column"
        >
          <div
            class="procedures-list-container"
            fxFlex.gt-sm="50"
            fxFlex.lt-md="100"
          >
            <div class="procedures-list">
              <div
                class="procedures-list-header"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <h3
                  class="procedures-list-title"
                  data-cy="promotional-smartshopper.procedures-list-title"
                >
                  {{ 'promotional_ss_list_title' | translate }}
                </h3>
                <div
                  class="procedure-count"
                  data-cy="promotional-smartshopper.procedures-count"
                  *ngIf="incentivizedProceduresCount && procedures?.length"
                  fxHide.lt-md
                >
                  {{ procedures.length }} {{ 'global_header_of' | translate }}
                  {{ incentivizedProceduresCount }}
                </div>
              </div>
              <div
                class="mobile-procedure-count"
                *ngIf="incentivizedProceduresCount && procedures?.length"
                fxHide.gt-sm
              >
                {{ 'promotional_ss_displaying' | translate }}
                {{ procedures.length }} {{ 'global_header_of' | translate }}
                {{ incentivizedProceduresCount }}
              </div>
              <ul class="procedure-list">
                <li
                  class="procedure"
                  *ngFor="
                    let procedure of procedures;
                    trackBy: trackByFnItemId;
                    let i = index
                  "
                  [attr.data-cy]="'promotional-smartshopper.procedure-' + i"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  tabindex="0"
                  appGtm
                  [gtmOnClick]="true"
                  [gtmData]="{
                    event: 'gtm.ss_procedure_list.terminal_procedure',
                    ss_procedure_list_terminal_procedure_name: procedure.name
                  }"
                  (click)="procedureSearch(procedure.id)"
                  (keydown.enter)="procedureSearch(procedure.id)"
                >
                  <div class="procedure-name link-blue">
                    <span *ngIf="procedure?.locale_name">{{
                      procedure.locale_name
                    }}</span>
                    <span *ngIf="!procedure?.locale_name">{{
                      procedure.name
                    }}</span>
                  </div>
                  <zelis-theme-lozenge
                    emphasis="high"
                    size="medium"
                    color="system-green"
                  >
                    {{ 'guided_search_incentives_earn_up_to' | translate }}
                    {{
                      procedure.high_incentive_amount
                        | currency: 'USD':'symbol':'1.0-0'
                    }}
                  </zelis-theme-lozenge>
                </li>
              </ul>
            </div>

            <div
              class="view-all-button-container pad top-3x bottom-3x"
              fxLayout="row"
              fxLayoutAlign="space-around center"
            >
              <button
                class="platform-button view-all-button"
                mat-flat-button
                color="accent"
                appGtm
                [gtmOnClick]="true"
                [gtmData]="{ event: 'gtm.ss_procedure_list.view_all' }"
                data-cy="promotional-smartshopper.view-all-button"
                (click)="openGuidedSearchProcedures()"
              >
                {{
                  'promotional_ss_view_all_procedures_count'
                    | translate: { count: incentivizedProceduresCount }
                }}
              </button>
            </div>
          </div>

          <div class="ss-explain" fxFlex.gt-sm="50" fxFlex.lt-md="100">
            <div class="row" fxLayout="row">
              <div class="icon" fxFlex.gt-sm="30" fxFlex.lt-md="nogrow">
                <img
                  src="assets/images/rts-computer.svg"
                  alt=""
                  aria-hidden="true"
                  class="inline"
                />
              </div>
              <div class="learn" fxFlex.gt-sm="70" fxFlex.lt-md="grow">
                <div
                  class="learn-text"
                  data-cy="promotional-smartshopper.compare"
                  [innerHTML]="'rts_compare_providers' | translate"
                ></div>
              </div>
            </div>

            <div class="row" fxLayout="row">
              <div class="icon" fxFlex.gt-sm="30" fxFlex.lt-md="nogrow">
                <img
                  [src]="scheduleIconSrc"
                  alt=""
                  class="inline"
                  aria-hidden="true"
                />
              </div>
              <div class="learn" fxFlex.gt-sm="70" fxFlex.lt-md="grow">
                <span
                  *ngIf="'smartshopper_pat_phone' | translate; else noNumber"
                >
                  <div
                    data-cy="promotional-smartshopper.schedule-or-call"
                    [innerHTML]="'rts_schedule_or_call' | translate"
                  ></div>
                  <a
                    class="fs-18px"
                    href="tel:{{ 'smartshopper_pat_phone' | translate }}"
                  >
                    {{ 'smartshopper_pat_phone' | translate }}.
                  </a>
                </span>
                <ng-template #noNumber>
                  <div [innerHTML]="'rts_schedule' | translate"></div>
                </ng-template>
              </div>
            </div>

            <div class="row" fxLayout="row">
              <div class="icon" fxFlex.gt-sm="30" fxFlex.lt-md="nogrow">
                <img
                  [src]="earnIconSrc"
                  alt=""
                  class="inline"
                  aria-hidden="true"
                />
              </div>
              <div class="learn" fxFlex.gt-sm="70" fxFlex.lt-md="grow">
                <div
                  class="learn-text"
                  data-cy="promotional-smartshopper.earn"
                  [innerHTML]="'rts_earn_reward' | translate"
                ></div>
                <div
                  class="earn-disclaimer pad top-2x bottom-6x"
                  data-cy="promotional-smartshopper.rewards-can-take"
                >
                  {{ 'rts_rewards_can_take' | translate }}
                </div>
              </div>
            </div>

            <div
              class="learn-more-button-container"
              fxLayout="row"
              fxLayoutAlign="space-around center"
            >
              <div
                class="icon"
                fxFlex.gt-sm="30"
                fxFlex.lt-md="nogrow"
                fxHide.lt-md
              ></div>
              <div
                class="learn learn-more"
                fxFlex.gt-sm="70"
                fxFlex.lt-md="grow"
              >
                <div class="learn-title">
                  <zelis-button
                    disabled="false"
                    size="medium"
                    color="system-blue"
                    variant="stroked"
                    fullWidth="false"
                    darkBackground="false"
                    truncate="false"
                    routerLink="sspromo"
                    queryParamsHandling="preserve"
                    data-cy="promotional-smartshopper.learn-more-button"
                    appGtm
                    [gtmOnClick]="true"
                    [gtmData]="{ event: 'gtm.ss_homepage_promo.learn_more' }"
                  >
                    {{ 'promotional_ss_learn_more' | translate }}
                  </zelis-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </platform-page-container>
  </div>
</div>
